export const LandingPageText = {
  _1: 'air quality info, ',
  _2: 'detailed, real-time and easy to use',
  _3: 'Comprehensive air quality information for every location',
  _4: 'real-time',
  _5: 'easy to use and interpret',
  _6: 'smooth integration',
  _7: 'Which Industries?',
  _8: 'Air quality is a hot topic for your customers!',
  _9: 'Integrate aircheckr into your services and improve the health & experience of your customers and the revenues & the innovative character of your organization',
  _10: 'Try aircheckr yourself!'
};

export const InteractiveMapText = {
  car: {
    title: 'Smart cars',
    body: 'I drive an electric car, but I am still breathing the exhaust of all other cars!'
  },
  bike: {
    title: 'Healthiest route',
    body: 'I bring my daughter to school  with a bike everyday. That\'s healthy, right?'
  },
  person: {
    title: 'Outdoors',
    body: 'We breathe up to 8 times more (bad) air when exercising. So, what is the best moment to do sports?'
  },
  home: {
    title: 'Home',
    body: 'I want to buy this house, but what air will my children breathe when they play in the yard?'
  },
  office: {
    title: 'Office',
    body: 'Does the ventilation system also consider the quality of the air outside?'
  },
  industry: {
    title: 'Intelligence',
    body: 'How does the air quality change over time and space?'
  }
}

export const VacancyText = {
  text: "<span>We are currently looking for an enthousiastic <strong>Project Manager/Business Developer aircheckr</strong>.</span><span>Are you the one?</span>",
  link: "http://nazka.be/jobs/Vacature_BusDev_EN.pdf",
  cta: "view vacancy"
}

export const IndustrySmallText = {
  auto: {
    title: 'Automotive',
    body: 'Make cars smart and healthy by automating A/C and providing your customers with the air quality info they need.'
  },
  ho: {
    title: 'Home & Office',
    body: 'Take ventilation systems, air purifiers or real estate websites to another level with top air quality data at street level'
  },
  outdoor: {
    title: 'Outdoor',
    body: 'Empower your customers with top air quality information in order to plan or track their activities.'
  },
  info: {
    title: 'Informative',
    body: 'Boost digital signage or informative websites with regularly changing air quality content (real-time & forecast).'
  },
  health: {
    title: 'Digital Health',
    body: 'Integrate aircheckr info, alerts and recommendations to adequately inform sensitive groups.'
  },
  intelli: {
    title: 'Intelligence',
    body: 'Use the powerful aircheckr database to extract the historical, real-time and prognosis data you need.'
  }
};

export const Quotes = [
  //==========================
  {
    key: 0,
    text: 'Real-time air quality data from aircheckr can empower many smart city services and businesses, positively impacting citizen life and work.',
    author: 'Davor Meersman, IMEC and Open & Agile Smart Cities'
  },
  {
    key: 1,
    text: 'Aircheckr is making clever use of data science to make solid, accurate, detailed and real-time air pollution predictions.',
    author: 'Nele Verbiest, Python Predictions'
  },
  {
    key: 2,
    text: 'Buyers want as much information as possible about the property where they will potentially live. Research among our users has shown that air quality is a parameter they like to consult.',
    author: 'Wendy Geeraert, CEO Co-Libry'
  }];

export const ApiShowcaseText = {
  title: 'Try the AirCheckr City Level API',
  subtitle: 'Explore air quality data by selecting a country, an administrative level and a region',
  selectCountry: 'Select Country',
  selectAdminLevel: 'Select Admin Level',
  adminLevels: {
    LAU2: 'LAU2 - Cities or communes',
    NUTS3: 'NUTS3 - Districts',
    NUTS2: 'NUTS2 - Provinces'
  },
  selectCity: 'Select A Region',
  searchCountries: 'Search countries...',
  searchCities: 'Search regions/cities...',
  noCountriesFound: 'No countries found',
  noCitiesFound: 'No cities found',
  apiResponse: 'API Response',
  loadingApiData: 'Loading API data...',
  errorCountries: 'Failed to load countries. Please try again later.',
  errorCities: 'Failed to load cities. Please try again later.',
  errorApiData: 'Failed to load API data. Please try again later.',
  footerNote: 'This demo is built on the <a href="https://www.aircheckr.com/api_docs/#/?id=city-level-api" target="_blank" rel="noopener noreferrer">City Level API endpoint</a>, but it is just a starting point. The Aircheckr API includes many more endpoints and possibilities - check out the <a href="https://www.aircheckr.com/api_docs" target="_blank" rel="noopener noreferrer">full API docs</a> to learn more.'
};

export default LandingPageText;



// WEBPACK FOOTER //
// ./src/input-text/en/landing_page.js